let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6C1sr")).then(() => parcelRequire('fjObP'));